import Enumerator from './Enumerator';

export const ownershipTypes = ['none', 'owner_occupied', 'investment'];

export class OwnershipType extends Enumerator {
  static default() {
    return this.of('none');
  }

  static of(option?: string) {
    let correctOption = option;
    switch (option) {
      case '1':
        correctOption = 'owner_occupied';
        break;
      case '2':
        correctOption = 'investment';
        break;
      default:
        break;
    }
    return this.enumValueOf(correctOption) || this.default();
  }
}

OwnershipType.initEnum({
  none: {
    get title() {
      return 'Select one';
    }
  },
  owner_occupied: {
    get title() {
      return 'Owner occupied';
    }
  },
  investment: {
    get title() {
      return 'Investment';
    }
  }
});

export default {
  ownershipTypes,
  OwnershipType
};
